import React from 'react';
import { Link } from 'react-router';
import _isObjectLike from 'lodash/isObjectLike';
import PropTypes from 'prop-types';

class InternalLink extends React.PureComponent {
  render() {
    const { path, ...otherProps } = this.props;
    // path can be either a string or an object like {path, targetBlank}
    const { path: builtPath, targetBlank } = _isObjectLike(path) ? path : { path, targetBlank: false };

    return (
      <Link to={builtPath} {...(targetBlank ? { target: '_blank' } : {})} {...otherProps} />
    );
  }
}

InternalLink.propTypes = {
  path: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      targetBlank: PropTypes.bool.isRequired,
    }),
  ]).isRequired,
};

export default InternalLink;



// WEBPACK FOOTER //
// ./components/core/internal/InternalLink.js